import { render, staticRenderFns } from "./RelatoriosCiclo.vue?vue&type=template&id=6d3f31c6&scoped=true"
import script from "./RelatoriosCiclo.vue?vue&type=script&lang=js"
export * from "./RelatoriosCiclo.vue?vue&type=script&lang=js"
import style0 from "./RelatoriosCiclo.vue?vue&type=style&index=0&id=6d3f31c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3f31c6",
  null
  
)

export default component.exports